export const BUSINESS_CONFIGURATION = `
query BusinessSettings {
  productCategories(first: 500){
    edges {
      node {
        id
        name
      }
    }
  }
  business {
    id
    name

    custom {
      greenCircleProductId: textValue(key: "greenCircleProductId")
      greenCircleClientFee: integerValue(key: "greenCircleClientFee")
    }
  }
}
`;

export const CREATE_PRODUCT_CATEGORY = `
mutation CreateProductCategory($input: CreateProductCategoryInput!) {
  createProductCategory(input: $input) {
    productCategory {
      id
    }
  }
}
`;

export const CREATE_PRODUCT = `
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      product {
        id
      }
    }
  }
`;

export const CREATE_BUSINESS_SCHEMA_FIELD = `
  mutation CreateBusinessSchemaField($input: CreateSchemaFieldInput!) {
    createSchemaField(input: $input) {
      schemaField {
        key
      }
    }
  }
`;

export const CREATE_SERVICE_SCHEMA_FIELD = `
  mutation CreateServiceSchemaField($input: CreateSchemaFieldInput!) {
    createSchemaField(input: $input) {
      schemaField {
        key
      }
    }
  }
`;

export const SAVE_BUSINESS_FIELD = `
  mutation SaveBusinessField($input: UpdateBusinessInput!) {
    updateBusiness(input: $input) {
      business {
        id
        custom {
          greenCircleProductId: textValue(key: "greenCircleProductId")
        }
      }
    }
  }
`;

export const CREATE_REPORT = `
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input) {
      report {
        id
        name
      }
    }
  }
`;

export const SERVICE_MENU = `
  query ServiceCategories {
    serviceCategories(first: 500) {
      edges {
        node {
          id
          name
          active

          services(first: 500) {
            edges {
              node {
                id
                name
                active

                custom {
                  greenCircleFee: integerValue(key: "greenCircleFee")
                }
              }
            }
          }
        }
      }
    }
  }
`;
